import React from 'react';

const Footer: React.FC = () => {
  return (
    <footer className="bg-white border-t py-4 text-center text-gray-600 text-sm">
      <p>&copy; Rukuse Technology Trust</p>
    </footer>
  );
};

export default Footer; 